module.exports = __webpack_public_path__ + "static/media/div5.0de0b9cd.jpg";